import { useState } from "react";
import { HiShare } from "react-icons/hi";

import ShareLinkModal from "./ShareLinkModal";
import styles from "./Message.module.scss";

interface ShareFileButtonProps {
  fileName: string;
  fileId: string;
}

/**
 * Opens the ShareLinkModal for a file message (file-api ADR 036).
 */
export default function ShareFileButton({
  fileName,
  fileId,
}: ShareFileButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        className={`${styles.deleteFile} bg-transparent bn pa0 dim pointer gray`}
        onClick={() => setIsOpen(true)}
        title={`Share ${fileName}`}
      >
        <HiShare size={18} />
      </button>
      {isOpen && (
        <ShareLinkModal
          fileName={fileName}
          fileId={fileId}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
